import { $ } from "@/common/Axios";

export default {
  /**
   * 校企学生
   */
  employee: {
    /*
     * 添加
     * enterpriseId 企业ID (integer query )
     * entryTime 入职时间 (string query )
     * id  (integer query )
     * operatingPost 工作岗位 (string query )
     * schoolRollId 合同id (integer query )
     * userId 用户ID (integer query )
     * workPhoto 工作证明 (string query )
     */
    post: (p, c) => $.post("/api/ums/enterprise/employee", p, c),
  },
  employee_changeEnterprise: {
    /*
     * 批量移交学生
     * newEnterpriseId 新企业ID (integer query required)
     * originEnterpriseId 原企业ID (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ums/enterprise/employee/changeEnterprise", p, c),
  },
  employee_getBySchoolRollId: {
    /*
     * 根据合同编号获取校企学生信息
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ums/enterprise/employee/getBySchoolRollId", p, c),
  },
  employee_list: {
    /*
     * 校企学生列表
     */
    get: (p, c) => $.get("/api/ums/enterprise/employee/list", p, c),
  },
  employee_updateEmployeeEnterprise: {
    /*
     * 批量更换企业-选择校企学生
     * enterpriseId 新企业ID (integer query required)
     * ids 校企学生列表IDS (array query required)
     */
    post: (p, c) =>
      $.post("/api/ums/enterprise/employee/updateEmployeeEnterprise", p, c),
  },

  /**
   * 校企
   */
  enterpriseCompany: {
    /*
     * 添加
     * contractPhoto 合同证明 (string query )
     * createId 创建人 (integer query )
     * developTime 开发时间 (string query )
     * dingDepartmentId  (integer query )
     * discountAmount 优惠金额 (number query )
     * docking 对接部门 总经办、工会、人事部、财务部、其他 (string query )
     * firstDiscountAmount 首次优惠金额 (number query )
     * id  (integer query )
     * logo 企业logo (string query )
     * name 企业名称 (string query )
     * scale 企业规模 50以下，100-300，300-500,500-1000,1000-5000,5000以上 (string query )
     * simpleName 简称 (string query )
     */
    post: (p, c) => $.post("/api/ums/enterprise/enterpriseCompany", p, c),
  },
  enterpriseCompany_changeCreate: {
    /*
     * 更换创建人
     * createId 创建人 (integer query required)
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ums/enterprise/enterpriseCompany/changeCreate", p, c),
  },
  enterpriseCompany_createQrCode: {
    /*
     * 生成企业优惠二维码
     * batch 批次 (string query required)
     * days 有效期（天） (integer query required)
     * enterpriseId 企业ID (integer query required)
     * extraInfos 自定义Json值 (string query required)
     * showTeacher 是否显示招生老师姓名:是、否 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ums/enterprise/enterpriseCompany/createQrCode", p, c),
  },
  enterpriseCompany_getQrCodeValue: {
    /*
     * 根据企业优惠二维码查询value
     * key key (string query required)
     */
    get: (p, c) =>
      $.get("/api/ums/enterprise/enterpriseCompany/getQrCodeValue", p, c),
  },
  enterpriseCompany_list: {
    /*
     * 企业列表
     */
    get: (p, c) => $.get("/api/ums/enterprise/enterpriseCompany/list", p, c),
  },
  enterpriseCompany_listSimple: {
    /*
     * 简易企业列表
     * discountFlag 是否有已申请优惠的企业, 1是 (integer query )
     * hasStudent 只选取有学生的企业, 1是 (integer query )
     * selfFlag 是否只看自己创建的企业, 1是 (integer query )
     */
    get: (p, c) =>
      $.get("/api/ums/enterprise/enterpriseCompany/listSimple", p, c),
  },
  enterpriseCompany_remove: {
    /*
     * 删除
     * id 企业ID (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ums/enterprise/enterpriseCompany/remove", p, c),
  },
  enterpriseCompany_transferCreate: {
    /*
     * 移交创建人
     * createId 原创建人 (integer query required)
     * newCreateId 新创建人 (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ums/enterprise/enterpriseCompany/transferCreate", p, c),
  },

  /**
   * 校企优惠
   */
  enterpriseCompanyDiscount_apply: {
    /*
     * 申请优惠
     * dingDepartmentId 钉钉部门ID (integer query )
     * discountAmount 优惠金额 (number query required)
     * enterpriseId 企业ID (integer query required)
     * firstDiscountAmount 首次优惠金额 (number query required)
     */
    post: (p, c) =>
      $.post("/api/ums/enterprise/enterpriseCompanyDiscount/apply", p, c),
  },
  enterpriseCompanyDiscount_list: {
    /*
     * 根据企业ID查询优惠金额记录
     * enterpriseId 企业ID (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ums/enterprise/enterpriseCompanyDiscount/list", p, c),
  },
  enterpriseCompanyDiscount_sync: {
    /*
     * 同步
     * instanceId 审批实例ID (string query required)
     */
    post: (p, c) =>
      $.post("/api/ums/enterprise/enterpriseCompanyDiscount/sync", p, c),
  },
};
